var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-dropdown",
    {
      staticClass: "mr-1",
      attrs: { size: "sm", variant: "primary" },
      on: {
        show: function ($event) {
          _vm.isDropdownOpen = true
        },
        hide: function ($event) {
          _vm.isDropdownOpen = false
        },
      },
      scopedSlots: _vm._u([
        {
          key: "button-content",
          fn: function () {
            return [
              _c(
                "span",
                {
                  staticClass: "dropdown-title",
                  class: { "has-count": _vm.shouldShowCount },
                  attrs: { "data-count": _vm.displayedTemplatesCount },
                },
                [_vm._v("\n      Templates\n    ")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "b-dropdown-form",
        [
          _c(
            "b-list-group",
            { attrs: { flush: "" } },
            [
              _c(
                "b-list-group-item",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center",
                },
                [
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: { size: "sm" },
                      on: { change: _vm.onSelectCurrentTemplate },
                      model: {
                        value: _vm.isSelectedCurrentTemplate,
                        callback: function ($$v) {
                          _vm.isSelectedCurrentTemplate = $$v
                        },
                        expression: "isSelectedCurrentTemplate",
                      },
                    },
                    [_vm._v("\n          Images in this template\n        ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-list-group-item",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center",
                },
                [
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: { size: "sm" },
                      on: { change: _vm.onSelectAllTemplates },
                      model: {
                        value: _vm.isSelectedAllTemplate,
                        callback: function ($$v) {
                          _vm.isSelectedAllTemplate = $$v
                        },
                        expression: "isSelectedAllTemplate",
                      },
                    },
                    [_vm._v("\n          All templates\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: {
                        size: "sm",
                        button: "",
                        "button-variant": _vm.showProjectNames
                          ? "primary"
                          : "outline-primary",
                      },
                      model: {
                        value: _vm.showProjectNames,
                        callback: function ($$v) {
                          _vm.showProjectNames = $$v
                        },
                        expression: "showProjectNames",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              modifiers: { hover: true },
                            },
                          ],
                          staticStyle: { "padding-right": "3px" },
                          attrs: {
                            title: _vm.showProjectNames
                              ? "Show Template Names"
                              : "Show Project Names",
                          },
                        },
                        [
                          _c("i", {
                            class: [
                              "fas",
                              _vm.showProjectNames ? "fa-file" : "fa-folder",
                            ],
                          }),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.templates, function (template) {
                return _c(
                  "b-list-group-item",
                  {
                    key: template.instanceId,
                    attrs: {
                      disabled:
                        _vm.getCurrentInstanceId === template.instanceId,
                    },
                  },
                  [
                    _c(
                      "b-form-checkbox",
                      {
                        attrs: {
                          disabled:
                            _vm.getCurrentInstanceId === template.instanceId,
                          size: "sm",
                        },
                        on: { change: _vm.onSelectTemplate },
                        model: {
                          value: template.isSelected,
                          callback: function ($$v) {
                            _vm.$set(template, "isSelected", $$v)
                          },
                          expression: "template.isSelected",
                        },
                      },
                      [
                        _vm.showProjectNames && template.project_name
                          ? [
                              _vm._v(
                                "\n            " +
                                  _vm._s(template.project_name) +
                                  "\n          "
                              ),
                            ]
                          : [
                              _vm._v(
                                "\n            " +
                                  _vm._s(template.name) +
                                  "\n          "
                              ),
                            ],
                      ],
                      2
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showApplyButton
        ? _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-end align-items-center w-100 py-2 px-3",
            },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("apply")
                    },
                  },
                },
                [_vm._v("\n      Apply\n    ")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }